module.exports = __webpack_public_path__ + "img/2.82b82579.jpg";